import axios from "axios";
import CryptoJS from "crypto-js";
import {
  browserName,
  osName,
  osVersion,
  isBrowser,
  isMobile,
  isDesktop,
  isTablet,
} from "react-device-detect";

import { baseUrl } from "../Constants/urlConfigs";
import { Constants } from "../Constants/Constants";

class APIService {
  login = (subscriberId, authentication) => {
    const url = `${baseUrl}/cbapi/login`;
    const userId =
      subscriberId === undefined || subscriberId === null ? "" : subscriberId;

    let config;
    if (authentication) {
      config = {
        params: {
          bot: "oriserve",
          type: "Authenticated",
          user: userId,
          gethelpOs: JSON.stringify({
            device: isMobile ? "Mobile" : isTablet ? "Tablet" : "Web",
            os: osName,
            osVersion: osVersion,
            browser: browserName,
          }),
        },
      };
    } else {
      if (subscriberId !== undefined && subscriberId !== "") {
        config = {
          params: {
            bot: "oriserve",
            type: "SemiAuthenticated",
            user: userId,
            authenticated: false,
            gethelpOs: JSON.stringify({
              device: isMobile ? "Mobile" : isTablet ? "Tablet" : "Web",
              os: osName,
              osVersion: osVersion,
              browser: browserName,
            }),
          },
        };
      } else {
        config = {
          params: {
            bot: "oriserve",
            type: "Unauthenticated",
            authenticated: false,
            gethelpOs: JSON.stringify({
              device: isMobile ? "Mobile" : isTablet ? "Tablet" : "Web",
              os: osName,
              osVersion: osVersion,
              browser: browserName,
            }),
          },
        };
      }
    }

    return axios.get(url, config);
  };

  userActivity = (data) => {
    const url = `${baseUrl}/cbapi/updatesession?bot=oriserve&action=${data}`;

    const bearerToken = sessionStorage.getItem("token");

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
    };

    return axios.post(url, {}, config);
  };

  storeAgentLogs = (datatoSent) => {
    const url = `${baseUrl}/cbapi/agentchathistory`;
    const bearerToken =
      Constants.env === "UAT"
        ? Constants.uatCoachScreenToken
        : Constants.prodCoachScreenToken;
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
    };
    return axios.post(url, datatoSent, config);
  };

  loginForLink = (userDetails) => {
    console.log("IN API 1", baseUrl, userDetails);

    localStorage.setItem("linkLoginOnce", true);

    const url = `${baseUrl}/cbapi/login`;

    let config;
    if (userDetails !== null && userDetails !== undefined) {
      config = {
        params: {
          bot: "oriserve",
          user: userDetails,
          gethelpOs: JSON.stringify({
            device: isMobile ? "Mobile" : isTablet ? "Tablet" : "Web",
            os: osName,
            osVersion: osVersion,
            browser: browserName,
          }),
        },
      };
    }
    return axios.get(url, config);
  };

  chatForLink = (token, refresh) => {
    const url = `${baseUrl}/cbapi/chat`;
    const bearerToken = sessionStorage.getItem("token");

    const params = {
      bot: "oriserve",
      input: null,
      token: token,
      refresh: refresh !== undefined || refresh !== null ? refresh : null,
    };

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
    };

    return axios.get(url, config);
  };

  mypackRedirection = (url, name, value) => {
    const params = {
      name: name,
      value: value,
    };
    return axios.post(url, params);
  };

  loginCount = (subId, bearerToken) => {
    const url = `${baseUrl}/cbapi/loginCount`;
    const params = { bot: "oriserve", user: subId };
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
    };
    return axios.get(url, config);
  };

  chat = (data, input, label) => {
    const url = `${baseUrl}/cbapi/chat`;
    const bearerToken = sessionStorage.getItem("token");
    const params = input
      ? {
          bot: "oriserve",
          code: data,
          input: encodeURIComponent(JSON.stringify(input)),
        }
      : {
          bot: "oriserve",
          code: data,
          label: encodeURIComponent(JSON.stringify(label)),
        };

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
    };
    return axios.get(url, config);
  };

  chatWithTokenOnly = (token) => {
    const url = `${baseUrl}/cbapi/chat`;
    const bearerToken = token;
    const params = { bot: "oriserve", code: null, input: null };

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
    };
    return axios.get(url, config);
  };

  chatPost = (data, input) => {
    const url = `${baseUrl}/cbapi/chat`;
    const bearerToken = sessionStorage.getItem("token");
    const params = input
      ? { bot: "oriserve", code: data }
      : { bot: "oriserve", code: data };

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
    };
    return axios.post(url, input, config);
  };

  chatPostPacks = (data, input) => {
    const url = `${baseUrl}/cbapi/chat`;
    const bearerToken = sessionStorage.getItem("token");
    const params = input
      ? { bot: "oriserve", code: data }
      : { bot: "oriserve", code: data };

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
    };
    return axios.post(url, input, config);
  };

  initialState = () => {
    const url = `${baseUrl}/cbapi/chat`;
    const bearerToken = sessionStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: { bot: "oriserve" },
    };
    return axios.get(url, config);
  };

  refreshChat = () => {
    const url = `${baseUrl}/cbapi/chat`;
    const bearerToken = sessionStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: { bot: "oriserve", refresh: null },
    };
    return axios.get(url, config);
  };

  refreshOnBackToMenu = () => {
    const url = `${baseUrl}/cbapi/chat`;
    const bearerToken = sessionStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: { bot: "oriserve", refresh: null, input: null },
    };
    return axios.get(url, config);
  };

  messageRedirect = (url, data) => {
    const bearerToken = sessionStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
    };
    return axios.post(url, data, config);
  };

  historyApi = (sessionId, source) => {
    const url = `${baseUrl}/cbapi/history`;
    const bearerToken = sessionStorage.getItem("token");
    const config = {
      headers: sessionId
        ? { Authorization: bearerToken }
        : { Authorization: `Bearer ${bearerToken}` },
      params: {
        bot: "oriserve",
        limit: "100",
        ascending: "true",
        sessionId: sessionId,
        source: source,
      },
    };
    return axios.get(url, config);
  };

  uploadMedia = (data) => {
    const url = `${baseUrl}/cbapi/userupload`;
    const bearerToken = sessionStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
    };
    const formData = new FormData();
    formData.append("file", data);
    return axios.post(url, formData, config);
  };

  encryption = (subId) => {
    let salt = "random_salt";
    let password = "tsapi^1uat@23";

    let key256 = CryptoJS.PBKDF2(password, salt, {
      keySize: 256 / 32,
      iterations: 65536,
      hasher: CryptoJS.algo.SHA256.create(),
    });

    let iv = CryptoJS.enc.Base64.parse("hKhEwBqH8/mHfOKGcoaI1A==");
    let cipherText = CryptoJS.AES.encrypt(subId, key256, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: iv,
    });

    return cipherText.toString();
  };

  agentStatus = (SubscriberID, User, RMN, securitykey, source, sessionID) => {
    const url = `${baseUrl}/cbapi/chattoagentStatus`;
    const bearerToken = sessionStorage.getItem("token");
    const config = {
      headers: sessionID
        ? { Authorization: bearerToken }
        : { Authorization: `Bearer ${bearerToken}` },
      params: {
        SubscriberID: SubscriberID,
        User: User,
        RMN: RMN,
        datetime: new Date().getTime(),
        source: source,
        securitykey: securitykey,
      },
    };
    return axios.get(url, config);
  };

  generateLitmusFeedback = async (userData) => {
    var urlToReturn = "";
    const url = Constants.litmusUrl;
    const data = userData;
    return axios.post(url, data);
  };
}

var apiService = new APIService();
export default apiService;
